<template>
    <div class="certificate-contact">
        <div class="certificate-name-en mb-4">{{ certificateData.name }}</div>
        <p class="certificate-description">{{ certificateData.description }}</p>

    </div>
</template>
<script>
export default {
    props: { certificateData:{
      type: Object,
      default: () => {},

    },
},
computed: {

  },
methods: {

  },
}
</script>
<style lang="">

</style>
